import React from "react";
import { Icon, Button, notification } from "antd";
import moment from "moment";
import axios from "axios";

import ModalLoading from "../../../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../../../shared/components/Modals/ModalViewer";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const RelatorioRestantes = ({ onEdit, onView, relatorio }) => {
    const { id, nome_aluno, data, ano_serie, professor_aee } = relatorio;
    const [modalVisible, setModalVisible] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [docs, setDocs] = React.useState([]);

    const gerarPdf = () => {
        setIsLoading(true);
        axios({
            method: "get",
            url: "/api/pdf/relatorio-individual",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso"),
                relatorioId: id
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento.");
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <>
            <div className="relatorio-item">
                <div className="relatorio-item-header">
                    <div className="relatorio-item-title">{nome_aluno}</div>
                    <div className="relatorio-item-opcoes">
                        <Button onClick={() => onView(id)}>
                            <Icon type="eye" />
                            Visualizar
                        </Button>
                        <Button onClick={() => onEdit(id)}>
                            <Icon type="edit" />
                            Editar
                        </Button>
                        <Button onClick={gerarPdf}>
                            <Icon type="download" />
                            PDF
                        </Button>
                    </div>
                </div>
                <div className="relatorio-item-body">
                    <span>
                        <strong>Data de criação:</strong> {moment(data).format("DD/MM/YYYY")}
                    </span>
                    <span>
                        <strong>Ano/Série:</strong> {ano_serie}
                    </span>
                    <span>
                        <strong>Professor:</strong> {professor_aee}
                    </span>
                </div>
            </div>
            <ModalLoading visible={isLoading} text="A gerar documento..." />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
        </>
    );
};

export default RelatorioRestantes;
